/* eslint-disable @typescript-eslint/naming-convention */
import 'bootstrap/dist/css/bootstrap.min.css';
import 'aos/dist/aos.css';
import AOS from 'aos';
import { useEffect } from 'react';

import {
  AboutUsSection,
  AppLayout,
  ContactForm,
  HeroSection,
  OurServicesSection,
  OurSolutionsSection,
} from '../../../components';
import JoinUsSection from '../../../components/sections/join/JoinUsSection';

export const HomeScreen = () => {
  /* ---------- init AOS ---------- */
  useEffect(() => {
    AOS.init({ duration: 1000, easing: 'ease-in-out', once: false });
  }, []);

  /* ---------- JSX ---------- */
  return (
    <AppLayout toggle="home">
      <HeroSection />
      <AboutUsSection />
      <JoinUsSection />
      <OurServicesSection />
      <OurSolutionsSection />

      {/* CONTACT US */}
      <section id="contact" className="relative py-24 bg-gradient-to-b from-[#03010E] to-[#020812]">
        <div className="container mx-auto px-6 md:px-12">
          <h3 className="text-3xl md:text-4xl font-extrabold mb-12 text-[#00D4FF] text-center">
            CONTACT US TODAY
          </h3>
          <ContactForm />
        </div>
      </section>
    </AppLayout>
  );
};
